import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphTip = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed'], entity.getIn(['field_text', 0, 'processed']));
  const variant = entity.getIn(['field_variant', 0, 'value'], '');
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkHref = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <Container className="Paragraph ParagraphTip">
      <div className="row">
        <div className="col-12 col-lg-8 offset-lg-2">
          <div className={`color-${variant} ParagraphTip__wrapper`}>
            <div className="ParagraphTip__icon__wrapper">
              <div className="ParagraphTip__icon">
                <div className="icon icon-light icon-variant-1" />
              </div>
              <h3 className="ParagraphTip__title--mobile">{title}</h3>
            </div>
            <h3 className="ParagraphTip__title">{title}</h3>
            {body && (
              <WysiwygField
                property="schema:text"
                className="ParagraphTip__body subheading2"
                html={body}
              />
            )}
            <div className="ParagraphTip__link__wrapper">
              {linkHref && linkTitle && (
                <div className="ParagraphTip__link">
                  <CoreLink to={linkHref}>
                    {linkTitle}
                    <div className="icon icon-chevron-right" />
                  </CoreLink>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphTip;
